import { FC } from 'react'
import { Row, Col, Icon, Image } from '@/client/components'
import * as S from './styles'
import { CustomersProps } from '../types'

export const Customers: FC<CustomersProps> = ({ customers }) => (
  <Row>
    <Col xs={12}>
      <S.Customers>
        {customers &&
          customers.length > 0 &&
          customers.map(({ name, image, link }) => (
            <S.Customer key={name} href={link}>
              <Image src={image.url} alt={image.alt} width={image.width} height={image.height} />

              <S.Link>
                <S.WrapIcon>
                  <Icon name='link' size='s8' />
                </S.WrapIcon>
              </S.Link>
            </S.Customer>
          ))}
      </S.Customers>
    </Col>
  </Row>
)
